import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { cn } from "@/lib/utils";
import { buildSimilarSpacesUrl } from "~/components/listings/utils";
import { ListingSaveButton } from "~/components/save/listing-save-button";
import { useListingData } from "~/context/ListingPageDataContext";
import { BookListingQuote, IFaqs } from "~/types/api-types";

import { ListingShareButton } from "../share/listing-share-button";

import { MobileBookListingButton } from "./book-listing/MobileBookListingSection/MobileBookListingButton";

type MobileFooterProps = {
  faqs?: IFaqs;
  isFav: boolean;
  isVisible: boolean;
  listingId: string;
  pageTitle: string;
  quote?: BookListingQuote;
  toggleFavorite: () => void;
};

const MobileFooter = ({
  faqs,
  isFav,
  isVisible,
  listingId,
  pageTitle,
  quote,
  toggleFavorite,
}: MobileFooterProps) => {
  const { data: listingData } = useListingData();

  const isListingPaused =
    listingData.listingStatus === "PAUSED" ||
    listingData.listingStatus === "PAUSED_INTERNALLY";

  const similarSpacesUrl = buildSimilarSpacesUrl({
    city: listingData.listingCity,
    state: listingData.listingState,
    useType: listingData.useType,
  });

  return (
    <div
      className={cn(
        "tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-border-t tw-border-gray-300 tw-bg-base-white tw-flex tw-gap-16 tw-px-16 tw-py-12 tw-transition-all tw-duration-300 tw-ease-in-out",
        {
          "tw-translate-y-0": isVisible,
          "tw-translate-y-full": !isVisible,
        },
      )}
    >
      <ListingShareButton
        appearance="white"
        category={listingData.category}
        emailShare={listingData.emailShare}
        fbShare={listingData.fbShare}
        isMDScreen={false}
        origin="share listing details"
        metro={listingData.metro}
        twitterShare={listingData.twitterShare}
        useLargeIcon
        useType={listingData.useType}
      />
      <ListingSaveButton
        toggleFavorite={toggleFavorite}
        listingId={listingId}
        isFav={isFav}
        isMDScreen={false}
        appearance="white"
        useLargeIcon
      />
      {isListingPaused ? (
        <Button
          appearance="purple"
          className="tw-flex-1"
          href={similarSpacesUrl}
        >
          <FormattedMessage defaultMessage="Browse similar spaces" />
        </Button>
      ) : (
        <MobileBookListingButton
          faqs={faqs}
          pageTitle={pageTitle}
          quote={quote}
        />
      )}
    </div>
  );
};

export { MobileFooter };
